






























import { mapGetters } from 'vuex';

import { DeviceEnum } from '../../enums';

import { MESSAGES_CONSTS } from '../../store/messages/messages.consts';

import { getDatepickerI18nConfig, UiDatepicker, UiSwitch } from '../keen-ui';

export default {
  name: 'schedule',
  components: {
    UiSwitch,
    UiDatepicker
  },
  computed: {
    ...mapGetters(MESSAGES_CONSTS.moduleName, {
      locale: MESSAGES_CONSTS.getters.locale
    }),
    datepickerProps: function (): Object {
      return {
        ...getDatepickerI18nConfig(this.locale),
        orientation: ((this.$epb.device > DeviceEnum.MOBILE) ? 'landscape' : 'portrait'),
        pickerType: ((this.$epb.device > DeviceEnum.MOBILE) ? 'popover' : 'modal'),
        disabled: this.alwaysActive,
        placeholder: this.alwaysActive ? this.messages.fields.placeholders.always : this.messages.fields.placeholders.scheduled,
        appendDropdownToBody: true
      };
    },
    activationDate: function (): Date {
      if (!!this.value && this.value.activationDate instanceof Date) {
        return new Date(this.value.activationDate.getUTCFullYear(), this.value.activationDate.getUTCMonth(),
          this.value.activationDate.getUTCDate());
      }
    },
    deactivationDate: function (): Date {
      if (!!this.value && this.value.deactivationDate instanceof Date) {
        return new Date(this.value.deactivationDate.getUTCFullYear(), this.value.deactivationDate.getUTCMonth(),
          this.value.deactivationDate.getUTCDate());
      }
    },
    getScheduleSwitchText: function (): string {
      return this.alwaysActive ? this.messages.fields.schedule.states.always : this.messages.fields.schedule.states.schedule;
    }
  },
  data: function () {
    return {
      alwaysActive: false
    };
  },
  props: {
    messages: Object,
    value: Object
  },
  methods: {
    onActivationDateChange: function (date: Date): void {
      this.value.activationDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    },
    onDeactivationDateChange: function (date: Date): void {
      this.value.deactivationDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999));
    },
    resetValuesIfScheduleDisabled: function (): void {
      if (this.alwaysActive) {
        this.value.deactivationDate = this.value.activationDate = undefined;
      }
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler: function () {
        if (!!this.value) {
          this.alwaysActive = !this.value.activationDate && !this.value.deactivationDate;
        }
        this.$emit('input', this.value);
      },
      deep: true
    }
  }
};
